import { create } from "zustand";
import { DELETE, GET, POST, UPDATE } from "../services/MainApi";
import toast from "react-hot-toast";
import { axiosUpload } from "../services/axios";


export const useAppStore = create((set, get) => ({
  themeMode: localStorage.getItem("themeMode") || 'light',
  routes:[],
  isFetching: false,
  showModal:false,
  modalCode: null,
  isLoading:false,
  isUploading: null,
  formSelectsLoading:{},
  componentsLoading: {},
  

  


  toggleTheme: () => {
    const theme = get().themeMode === 'light' ? 'dark' : 'light'
    localStorage.setItem("themeMode", theme);
    set({ themeMode: theme });
  },



   setFormSelectsLoading: (selectLoading) => {
    const {key,value}= selectLoading
      set(state => ({
       formSelectsLoading: {...state.formSelectsLoading, [key]:value }
    }))
  },

  setComponentLoading: (compLoading) => {
    const {compId,value}= compLoading
    set(state => ({
      componentsLoading: {...state.componentsLoading, [compId]:value }
     }))
  },



fetchData : async () => {
    set({ isFetching: true });

  try {
     const res = await GET(null,'Routes.php',null);

    set({ routes: res.data.data});
    } catch (error) {
        
        console.log("Error In logout: ",error)
    
  }finally{
   set({ isFetching: false });
  }


},






  addNewUpload: ( tempId , comp_id , route , title ) =>{

  
  const newUpload = {
  comp_id:comp_id , 
  route:route,
  title:`${title} - ${tempId}`,
  progress:0
  }

    set(state => ({
      isUploading: {...state.isUploading , [tempId] :newUpload   }
    }))

  },


  updateUpload: ( tempId, progress ) =>{

   
 const { isUploading } = get();

   const uploadItem = isUploading[tempId];

    set(state => ({
      isUploading: {...state.isUploading, [tempId] : {...uploadItem, progress : progress }}
    }))

  },


  
 removeUpload: (tempId) => {
  set((state) => {
    // Extract the key to remove into a throwaway variable (_)
    // and collect the rest into a new object (remainingUploads)
    const { [tempId]: _, ...remainingUploads } = state.isUploading;

    return {
      isUploading: remainingUploads,
    };
  });
},




  setShowModal: (show) => set({ showModal: show }),
  
  setLoading: (value) => set({ isLoading: value  }),


  stopMainLoading: () => {
   
      set({ isLoading: false });

  },
 

  Get: async (token,api,others) => {
    try {
      const res = await GET('',api,others)
      
      return res.data;
 
    } catch (error) {

    console.log(`Error in Get ${api}:`, error);

     const API = typeof api === 'string' ? api.toUpperCase().replaceAll(".PHP", "") : "";

     toast.error(`Error in Get ${API}`);
     
       get().stopMainLoading()

        return null;

    }
  },



   Post: async (token,api,data) => {
    try {
      
      const res = await POST('',api,data)
      
      return res.data;
 
    } catch (error) {

    console.log(`Error in Post ${api}:`, error);

     const API = typeof api === 'string' ? api.toUpperCase().replaceAll(".PHP", "") : "";

     toast.error(`Error in Post ${API}`);
        get().stopMainLoading()
     
    return null;

    } 
  },



   Update: async (token,api,data) => {
    try {
        
      const res = await UPDATE('',api,data)
      
      return res.data;
 
    } catch (error) {

    console.log(`Error in Update ${api}:`, error);

     const API = typeof api === 'string' ? api.toUpperCase().replaceAll(".PHP", "") : "";

     toast.error(`Error in Update ${API}`);
        get().stopMainLoading()
        return null;

    } 
  },



   Delete: async (token,api,data) => {
    try {
        
      const res = await DELETE('',api,data)
      
      return res.data;
 
    } catch (error) {

    console.log(`Error in Delete ${api}:`, error);

     const API = typeof api === 'string' ? api.toUpperCase().replaceAll(".PHP", "") : "";

     toast.error(`Error in Delete ${API}`);
     
   
     
        return null;

    } 
  },


  
  Upload: async (api,formData,comp_id,route,title) => {


      const temp_id = `Temp-${comp_id}_${Date.now()}`;

      get().addNewUpload(temp_id,comp_id,route,title);
      
    try {
      const res =  await axiosUpload.post(api, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
        onUploadProgress: (progressEvent) => {
           const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);

           get().updateUpload(temp_id,percentCompleted);

           console.log("Overall Progress: "+percentCompleted+"%");
        }
      });
      
      return res.data;
 
    } catch (error) {

    console.log(`Error in Get ${api}:`, error);

    get().removeUpload(temp_id);
     const API = typeof api === 'string' ? api.toUpperCase().replaceAll(".PHP", "") : "";

     toast.error(`Error in Upload ${API}`);
     
       get().stopMainLoading()

        return null;

    }
  },



}));
